export default "__VITE_ASSET__a0ed5464__"